export default "__VITE_ASSET__a63d3fab__"